import { render, staticRenderFns } from "./programs-table.vue?vue&type=template&id=276e87a4&"
import script from "./programs-table.vue?vue&type=script&lang=ts&"
export * from "./programs-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports